import React from "react";
import { List } from "@material-ui/core";

export const MarkdownList = ({ children }) => {
  return (
    <List dense disablePadding>
      {children}
    </List>
  );
};
